import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./cardGrid.html";
class CardGrid extends LightningElement {
  constructor(...args) {
    super(...args);
    this.columnSize = undefined;
    this.columnGap = undefined;
    this.listingRecords = [];
    this.isLoading = false;
    this.skeletonCount = 0;
    this.cardFocusIdx = undefined;
    this.navigatedWithKeyboard = false;
  }
  renderedCallback() {
    if (typeof this.cardFocusIdx === 'number') {
      const allCards = this.template?.querySelectorAll('wds-listing-card');
      allCards?.[this.cardFocusIdx]?.focus();
      if (this.navigatedWithKeyboard) {
        allCards?.[this.cardFocusIdx]?.blur();
      }
    }
  }
  get listingSkeletons() {
    const skeletons = [];
    for (let i = 0; i < this.skeletonCount; i++) {
      const skeleton = {
        id: i
      };
      skeletons.push(skeleton);
    }
    return skeletons;
  }
  /*LWC compiler v7.1.3*/
}
CardGrid.delegatesFocus = true;
_registerDecorators(CardGrid, {
  publicProps: {
    columnSize: {
      config: 0
    },
    columnGap: {
      config: 0
    },
    listingRecords: {
      config: 0
    },
    isLoading: {
      config: 0
    },
    skeletonCount: {
      config: 0
    },
    cardFocusIdx: {
      config: 0
    },
    navigatedWithKeyboard: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(CardGrid, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;